import React, { useEffect, useState, useRef } from 'react';
import '../styles/App.css';

// 分类类型定义
interface Category {
    id: string;
    name: string;
    parentId: string;
    index?: number;
}

const Footer: React.FC = () => {
    const [, setCategories] = useState<Category[]>([]);
    const categoriesRef = useRef<Category[]>([]);

    useEffect(() => {
        // 先从 localStorage 读取分类
        const cached = localStorage.getItem('categories');
        if (cached) {
            try {
                const cats = JSON.parse(cached);
                categoriesRef.current = cats;
                setCategories(cats);
            } catch { }
        }
    }, []);

    // 一级分类
    const topCategories = categoriesRef.current.filter(cat => cat.parentId === "null");
    const sortedTopCategories = [...topCategories].sort((a, b) => (a.index ?? 0) - (b.index ?? 0));

    return (
        <>
            <footer className="footer-custom">
                <div className="footer-section logo-section">
                    <img
                        src="/logo.png"
                        alt="logo"
                        className="footer-logo"
                        onClick={() => window.location.href = '/'}
                        style={{ cursor: 'pointer' }}
                    />
                </div>
                <div className="footer-section company-section">
                    <h4>COMPANY</h4>
                    <ul>
                        <li><a href="/about">About Us</a></li>
                        <li><a href="/ideas">Ideas & Inspiration</a></li>
                    </ul>
                </div>
                <div className="footer-section shopping-section">
                    <h4>SHOPPING</h4>
                    <ul>
                        {sortedTopCategories.map(cat => (
                            <li key={cat.id}><a href={`/category/${cat.id}`}>{cat.name}</a></li>
                        ))}
                    </ul>
                </div>
                <div className="footer-section contact-section">
                    <h4>CONTACT INFO</h4>
                    <ul>
                        <li>
                            📞 <a href="tel:4162978088">416-297-8088</a>
                        </li>
                        <li>
                            ✉️ <a href="mailto:gracioushome.ca@gmail.com">gracioushome.ca@gmail.com</a>
                        </li>
                        <li>
                            📍 <a href="https://www.google.com/maps/place/41+Passmore+Ave+Unit+1,+Scarborough,+ON+M1V+4T1/@43.7720004,-79.2420004,17z/data=!3m1!4b1!4m6!3m5!1s0x882b349000000000:0x6600000000000000!8m2!3d43.7720004!4d-79.2398117!16s%2Fg%2F11c484x1jg?entry=ttu&g_ep=EgoyMDI1MDIwMi4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">41 Passmore Ave Unit 1, Scarborough, ON M1V 4T1</a>
                        </li>
                    </ul>
                </div>
            </footer>
            <div className="footer-copyright">
                <p>&copy; Gracious Home All Rights Reserved.</p>
            </div>
        </>
    );
};

export default Footer; 